import { getFeatureFlagValue } from './helper';
import { IDispatchManagerFeatures } from './interface';

export const dispatchManagerFeatures: IDispatchManagerFeatures = {
    isHideIntimetecMailIdUsers: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_HIDE_INTIMETEC_MAIL_ID_USERS,
    ),
    isShowSettingsInvoicing: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_SETTINGS_INVOICING,
    ),
    isRateBeingEntered: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_RATE_BEING_ENTERED,
    ),
    isShowInputAndDocumentPreferences: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_INPUT_AND_DOCUMENT_PREFERENCES,
    ),
    isShowSubscriptionComponent: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_SUBSCRIPTION_COMPONENT,
    ),
    isShowAllActivityItems: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_ALL_ACTIVITY_ITEMS,
    ),
    isShowBOLRequiredInMobileApp: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_BOL_REQUIRED_IN_MOBILE_APP,
    ),
    isAxiosApiCallNewImplementation: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_AXIOS_API_CALL_NEW_IMPLEMENTATION,
    ),
    isShowGeneralBrokerFee: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_GENERAL_BROKER_FEE,
    ),
    isShowSettlementReportModal: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_SETTLEMENT_REPORT_MODAL,
    ),
    isShowRoundInvoiceTotals: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_ROUND_INVOICE_TOTALS,
    ),
    isShowHeadCountOrQuantitySection: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_223080_IS_SHOW_HEAD_COUNT_OR_QUANTITY_SECTION,
    ),
    isShowOldSettlementReport: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_OLD_SETTLEMENT_REPORT,
    ),
    isProfileImageOverlayRestricted: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_223169_IS_PROFILE_IMAGE_OVERLAY_RESTRICTED,
    ),
    isAbleToUploadHeicHeif: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_241620_IS_ABLE_TO_UPLOAD_HEIC_HEIF,
    ),
    isShowModalOnAttachmentDelete: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_241911_SHOW_MODAL_ON_ATTACHMENT_DELETE,
    ),
    isEnhancedLoadBoardEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_ENHANCED_LOAD_BOARD_ENABLED,
    ),
    showUpdateSignupPage: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_241940_SHOW_UPDATE_SIGNUP_PAGE,
    ),
    isBreakdownDriverDeletionRestricted: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_242562_RESTRICT_BREAKDOWN_DRIVER_DELETION,
    ),
    showSendSettlementReportToQuickBooks: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242691_SETTLEMENT_REPORT_TO_QB,
    ),
    isPosthogOn: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_POSTHOG_ON,
    ),
    isShowUpdateDriverCard: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_196665_IS_SHOW_UPDATE_DRIVER_CARD,
    ),
    isShowPreserveOwnerOperatorPercent: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242383_PRESERVE_OWNER_OPERATOR_PERCENT,
    ),
    showCargoSectionUIBugFix: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242943_CARGO_SECTION_UI_BUG,
    ),
    showTemplateFeature: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242133_SHOW_TEMPLATE_FEATURE,
    ),
    showManualConnectFeature: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242209_SHOW_MANUAL_CONNECT_FEATURE,
    ),
    fixManualConnectPlaceholderDriver: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_244746_FIX_MANUAL_CONNECT_PLACEHOLDER_DRIVER,
    ),
    isODataFilterFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_ODATA_FILTER_FIX_ENABLED,
    ),
    isSettlementReportEditingValidationEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_243121_SETTLEMENT_REPORT_EDITING_VALIDATION,
    ),
    isAdditionalChargeValidationEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_244164_IS_ADDITIONAL_CHARGE_VALIDATION_ENABLED,
    ),
    hideCustomerPhoneNumberInTemplate: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_HIDE_CUSTOMER_PHONE_NUMBER_IN_TEMPLATE,
    ),
    isMCSFeatureEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_MCS_FE,
    ),
    isShowUpdatedAssignedDriverCount: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_244776_IS_SHOW_ASSIGNED_DRIVER_COUNT,
    ),
    isMandatoryDriverValidationEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_MANDATORY_DRIVER_VALIDATION_ENABLED,
    ),
    isSyncBackUnsavedLoadDataFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM_244795_IS_SYNC_BACK_UNSAVED_LOAD_DATA_FIX_ENABLED,
    ),
    isMultipleDispatchBugFixEnabledForDuplicateLoads: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM_244853_IS_MULTIPLE_DISPATCH_BUG_FIX_ENABLED_FOR_DUPLICATE_LOADS,
    ),
    isShowMCSShipmentModalOnBuild: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_SHOW_MCS_SHIPMENT_MODAL_ON_BUILD,
    ),
    isBrokerFeeEmptyValueFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_IS_BROKER_FEE_EMPTY_VALUE_FIX_ENABLED,
    ),
    isDM245092ShipmentDetailOptimizationV1Enabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM245092_SHIPMENT_DETAIL_OPTIMIZATION_V1_ENABLED,
    ),
    isCustomerScopedBrokerFeeEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_CUSTOMER_SCOPED_BROKER_FEE_ENABLED,
    ),
    isMCSBackendPdfGenerationEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DM_MCS_GENERATE_INVOICE_PDF_IN_BACKEND,
    ),
    isMCSSaveAndCloseOrderEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245470_MCS_SAVE_AND_CLOSE_ORDER,
    ),
    isMCSSaveToastEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245470_MCS_SAVE_TOAST,
    ),
    isSaveAndContinueButtonFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245470_SAVE_AND_CONTINUE_BUTTON_FIX,
    ),
    isSequentialDriverLoadAttachmentUploadEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_SEQUENTIAL_DRIVER_LOAD_ATTACHMENT_UPLOAD_ENABLED,
    ),
    isStartAndEndDateRangeIssueFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_223228_DATE_RANGE_ISSUE_FIX,
    ),
    isUpdatedMultipleInvoiceModalEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245600_UPDATED_MULTIPLE_INVOICE_MODAL,
    ),
    isCoordinateNormalizationEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245621_COORDINATE_NORMALIZATION,
    ),
    isGeofencingFeatureEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_GEOFENCING_FEATURE_ENABLED,
    ),
    isGeofenceAlwaysVisibleEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245987_GEOFENCE_ALWAYS_VISIBLE_ENABLED,
    ),
    showPopupWhileDeactivatingCustomer: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_241910_SHOW_POPUP_WHILE_DEACTIVATING_CUSTOMER,
    ),
    isDeletedCargoInDriverLoadFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM_243571_DELETED_CARGO_IN_DRIVER_LOAD_FIX_ENABLED,
    ),
    isBreakdownLocationLoadingStateEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_245385_BREAKDOWN_LOCATION_LOADING_STATE_ENABLED,
    ),
    isPasswordSpecialCharValidationFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_243749_PASSWORD_SPECIAL_CHAR_VALIDATION_FIX,
    ),
    isInvoiceRecipientCustomerIdFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_245994_INVOICE_RECIPIENT_CUSTOMER_ID_FIX_ENABLED,
    ),
    isDateRangeInputErrorStateFix: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_243740_DATE_RANGE_INPUT_ERROR_STATE_FIX,
    ),
    isPhoneNumberClearIssueInGeoFencingEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_246264_PHONE_NUMBER_CLEAR_ISSUE_IN_GEOFENCING,
    ),
    isTrailerSizePreferencesEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_246227_TRAILER_SIZE_PREFERENCES_ENABLED,
    ),
    isShipmentUpdateApiIssueFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_246437_SHIPMENT_UPDATE_API_ISSUE_FIX,
    ),
    isPopulateFieldsBeforeEditInGeofenceFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_246369_POPULATE_ALL_FIELDS_BEFORE_EDIT_IN_GEOFENCE,
    ),
    isEmptyReportIssueFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_246608_FIX_EMPTY_REPORT_API_ISSUE,
    ),
    isShipmentDetailPageAfterDeletionFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_246525_FIX_DISPLAY_SHIPMENT_DETAILS_AFTER_DELETION,
    ),
    isGeofenceFixIssuesFlagEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_246738_FIX_GEOFENCE_ISSUES,
    ),
    isEditTemplatesEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242535_EDIT_TEMPLATES_ENABLED,
    ),
    isBrokenEmailValidationFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DM247878_BROKEN_EMAIL_VALIDATION,
    ),
    isBlankScreenFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DM248098_BLANK_SCREEN_FIX,
    ),
};
